import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import PageWrapper from "../components/PageWrapper";
import FAQItem from "../components/FAQItem";
import "./Support.css";

const contactEmail = "hello@mindblows.com";

export default function Support() {
  const { t } = useTranslation();
  const [emailFeedback, setEmailFeedback] = useState("");

  const faqs = [
    { question: t("q1"), answer: t("a1") },
    { question: t("q2"), answer: t("a2") },
    { question: t("q3"), answer: t("a3") },
    { question: t("q4"), answer: t("a4") },
    { question: t("q5"), answer: t("a5") },
    { question: t("q7"), answer: t("a7") },
    { question: t("q8"), answer: t("a8") },
    { question: t("q6"), answer: t("a6") },
  ];

  const handleEmailClick = async () => {
    const mailto = `mailto:${contactEmail}?subject=${encodeURIComponent(t("support_email_subject"))}`;

    const link = document.createElement("a");
    link.href = mailto;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    try {
      await navigator.clipboard.writeText(contactEmail);
      setEmailFeedback(t("support_email_copied"));
    } catch {
      setEmailFeedback(t("support_email_fallback"));
    }

    setTimeout(() => setEmailFeedback(""), 4000);
  };

  return (
    <PageWrapper>
      <div className="support-page">
        <header className="support-header">
          <h1>{t("support_title")}</h1>
          <p>{t("support_subtitle")}</p>
        </header>

        <section className="support-contact">
          <h2>{t("support_contact_title")}</h2>
          <p>{t("support_contact_desc")}</p>
          <button
            type="button"
            className="support-email"
            onClick={handleEmailClick}
          >
            {contactEmail}
          </button>
          {emailFeedback && (
            <p className="support-email-feedback">{emailFeedback}</p>
          )}
          <p className="support-response">{t("support_response_time")}</p>
        </section>

        <section className="support-faq">
          <h2>{t("faq_title")}</h2>
          <div className="support-faq-list">
            {faqs.map(({ question, answer }) => (
              <FAQItem key={question} question={question} answer={answer} />
            ))}
          </div>
        </section>

        <section className="support-links">
          <p>
            {t("support_related_links")}{" "}
            <Link to="/privacy-policy">{t("privacy_policy")}</Link>
            {" · "}
            <Link to="/terms">{t("terms")}</Link>
          </p>
        </section>
      </div>
      <Footer />
    </PageWrapper>
  );
}
